import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Box } from '@material-ui/core';

const TabPanel = props => {
	const { children, value, index, tabId, tabPanelAria, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`${tabPanelAria}-${index}`}
			aria-labelledby={`${tabId}-${index}`}
			{...other}
		>
			{value === index && (
				<Box p={2} className="tab-panel__data">
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
};

export default TabPanel;

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired
};
